import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = {
  class: "modal-content",
  style: {"height":"calc(100vh - 50px)"}
}
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "text-lowercase" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "d-flex justify-content-end" }
const _hoisted_14 = { class: "dropdown" }
const _hoisted_15 = {
  class: "dropdown-menu dropdown-menu-right",
  style: {"overflow-y":"auto","max-height":"400px"}
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "form-group" }

import { computed, ref, toRef } from 'vue'

    import { insertIntoTextArea1 } from '@common/Common'

    import type {
        AlternativesViewReadModel,
        AttributeReadModel
    } from '@Evaluation/Estimations/Domain/readmodels'

    import
        {
            PanelAlternativesManagerSaveEventPayload
        } from '@Evaluation/Estimations/Components/PanelAlternativesManager'
    import type {
        PanelAlternativesManagerViewModel
    } from '@Evaluation/Estimations/Components/PanelAlternativesManager'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PanelAlternativesManager',
  props: {
    viewModel: {}
  },
  emits: ["save"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- refs ----------------

    const ta = ref<HTMLTextAreaElement | null>(null)

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const alternativesLabel = computed(() => vm.value.alternativesLabel)
    const attributes = computed<AttributeReadModel[]>(() => vm.value.attributes)
    const views = computed<AlternativesViewReadModel[]>(() => vm.value.views)
    const emailAttributes = computed<AttributeReadModel[]>(() => vm.value.emailAttributes)

    const descriptionTemplate = computed<string>({
        get: () => vm.value.descriptionTemplate,
        set: val => { vm.value.descriptionTemplate = val }
    })

    const viewDefId = computed<string | null>({
        get: () => vm.value.viewDefId,
        set: val => { vm.value.viewDefId = val }
    })

    const attributeId = computed<number | null>({
        get: () => vm.value.attributeId,
        set: val => { vm.value.attributeId = val }
    })

    // ---------------- actions ----------------

    function insert(txtToAdd: string)
    {
        if (!ta.value)
            return

        insertIntoTextArea1(ta.value, txtToAdd)
        ta.value.dispatchEvent(new Event('input'))
    }

    function save()
    {
        const payload = new PanelAlternativesManagerSaveEventPayload(
            vm.value.surveyId,
            descriptionTemplate.value,
            viewDefId.value,
            attributeId.value
        )

        emit('save', payload)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, [
                  _cache[5] || (_cache[5] = _createTextVNode("Manage ", -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(alternativesLabel.value), 1 /* TEXT */)
                ]),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", null, "List:", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((viewDefId).value = $event)),
                    class: "form-control"
                  }, [
                    _cache[6] || (_cache[6] = _createElementVNode("option", { value: null }, "All", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(views.value, (v) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: v.Id
                      }, _toDisplayString(v.Name), 9 /* TEXT, PROPS */, _hoisted_10))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, viewDefId.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", null, "Filter by attribute:", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((attributeId).value = $event)),
                    class: "form-control"
                  }, [
                    _cache[8] || (_cache[8] = _createElementVNode("option", { value: null }, "No selection", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emailAttributes.value, (attr) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: attr.AttributeId
                      }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_12))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, attributeId.value]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[10] || (_cache[10] = _createElementVNode("button", {
                        class: "btn btn-sm btn-secondary dropdown-toggle",
                        "data-toggle": "dropdown"
                      }, "Insert", -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (insert('{Description}')))
                        }, "Description"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (insert('{Status}')))
                        }, "Status"),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributes.value, (attr) => {
                          return (_openBlock(), _createElementBlock("a", {
                            class: "dropdown-item",
                            key: attr.AttributeId,
                            onClick: ($event: any) => (insert(`{${attr.Name}}`))
                          }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_16))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("textarea", {
                      ref_key: "ta",
                      ref: ta,
                      rows: "5",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((descriptionTemplate).value = $event)),
                      class: "form-control"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        descriptionTemplate.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _cache[11] || (_cache[11] = _createElementVNode("small", { class: "form-text text-muted" }, null, -1 /* CACHED */))
                  ])
                ])
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: save,
                  type: "button",
                  class: "btn btn-primary"
                }, "Save & Close"),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})